import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfinitePatientsResponse } from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllPatients");

type IResponse = IWithInfinite<IInfinitePatientsResponse>;
type IVariables = NonNullable<unknown>;

const getAllInfinitePatients = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfinitePatients = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfinitePatients({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
